import React from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

import { addOrUpdateSteamHumidifyPoint } from "../../../actions/summerPointsActions";
import { useEffect, useRef, useState, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { weatherCtx } from "../../../utils/hooks/mollierWeatherContext";
import { addOrUpdateSteamHumidifyPointWinter } from "../../../actions/winterPointsActions";
import { handleKeyPressOnlyNumbers } from "../../../utils/validationFunctions";

function SteamHumidifing(props) {
  const [relativeHumidity, setRelativeHimidity] = useState();
  const [absoluteHumidity, setAbsoluteHumidity] = useState();
  const [steamingProccessVariable, setSteamingProcessVariable] = useState(10);
  const isFirstRender = useRef(true);
  const dispatch = useDispatch();
  const { summerWeather } = useContext(weatherCtx);
  const { chartConfig } = useContext(weatherCtx);
  const [localValue, setLocalValue] = useState(props.relativeHumidity);
  useEffect(() => {
    setLocalValue(props.relativeHumidity);
  }, [props.relativeHumidity]);

  // Effect to update the Redux store value whenever the localValue changes
  /*useEffect(() => {
    summerWeather
      ? dispatch(
          addOrUpdateSteamHumidifyPoint(
            localValue,
            chartConfig.altitude,
            props.processID
          )
        )
      : dispatch(
          addOrUpdateSteamHumidifyPointWinter(
            localValue,
            chartConfig.altitude,
            props.processID
          )
        );
  }, [dispatch, localValue, chartConfig]);*/

  const handleProcessChange = () => {
    summerWeather
      ? dispatch(
          addOrUpdateSteamHumidifyPoint(
            localValue,
            chartConfig.altitude,
            props.processID
          )
        )
      : dispatch(
          addOrUpdateSteamHumidifyPointWinter(
            localValue,
            chartConfig.altitude,
            props.processID
          )
        );
  };
  /* useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return; // Skip the first render
    }
    summerWeather
      ? dispatch(
          addOrUpdateSteamHumidifyPoint(
            relativeHumidity,
            chartConfig.altitude,
            props.processID
          )
        )
      : dispatch(
          addOrUpdateSteamHumidifyPointWinter(
            relativeHumidity,
            chartConfig.altitude,
            props.processID
          )
        );
  }, [relativeHumidity]);*/

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid
        container
        spacing={1}
        alignItems="center"
        justifyContent="start"
        direction="row"
      >
        <Grid item xs={5} mt={1}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Parameter for calculation
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={steamingProccessVariable}
              label="Parameter for calculation"
              defaultValue={10}
              onChange={(event) => {
                setSteamingProcessVariable(event.target.value);
              }}
            >
              <MenuItem value={10}>Relative humidity</MenuItem>
              <MenuItem value={20}>Absolute humidity</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={5}>
          {steamingProccessVariable === 10 && (
            <TextField
              label="Relative Humidity"
              id="outlined-start-adornment"
              name="relativeHumidity"
              value={localValue}
              // sx={{ m: 1, width: "25ch" }}
              InputProps={{
                endAdornment: <InputAdornment position="end">%</InputAdornment>,
              }}
              onChange={(e) => {
                setLocalValue(e.target.value);
              }}
              onBlur={handleProcessChange}
              onKeyPress={handleKeyPressOnlyNumbers}
            />
          )}
          {steamingProccessVariable === 20 && (
            <TextField
              label="Absolute Humidity"
              id="outlined-start-adornment"
              name="absoluteHumidity"
              value={localValue}
              // sx={{ m: 1, width: "25ch" }}
              InputProps={{
                endAdornment: <InputAdornment position="end">%</InputAdornment>,
              }}
              onChange={(event) => {
                setLocalValue(event.target.value);
              }}
              onKeyPress={handleKeyPressOnlyNumbers}
            />
          )}
        </Grid>
      </Grid>{" "}
    </Box>
  );
}

export default SteamHumidifing;
